import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9bc7756a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mobile-wrap d-full d-flex-column" }
const _hoisted_2 = {
  class: "d-overflow d-full",
  ref: "bodyOverflow"
}
const _hoisted_3 = {
  ref: "video",
  id: "player-container-id",
  class: "video",
  autoplay: "",
  playsinline: "",
  "webkit-playsinline": ""
}
const _hoisted_4 = { class: "boday" }
const _hoisted_5 = { class: "part1 d-flex van-row--align-center van-row--justify-center" }
const _hoisted_6 = { class: "name" }
const _hoisted_7 = { class: "part2 d-flex van-row--align-center van-row--justify-center" }
const _hoisted_8 = { class: "quantity" }
const _hoisted_9 = { class: "time" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1))
const _hoisted_11 = { class: "detail" }
const _hoisted_12 = { class: "goods service d-flex" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "divIcon" }, null, -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex-1f name" }, "热门推荐", -1))
const _hoisted_15 = { style: {"height":"100%","width":"105px","flex-shrink":"0"} }
const _hoisted_16 = { class: "part2 van-row--align-center van-row--justify-center" }
const _hoisted_17 = { class: "name oneLineText d-flex" }
const _hoisted_18 = { class: "commendDetail" }
const _hoisted_19 = { class: "more d-flex van-row--align-center van-row--justify-center" }
const _hoisted_20 = { class: "quantity oneLineText" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RatioHeightContainer = _resolveComponent("RatioHeightContainer")!
  const _component_van_row = _resolveComponent("van-row")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_image = _resolveComponent("van-image")!
  const _component_van_tag = _resolveComponent("van-tag")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_RatioHeightContainer, { ratio: 56.25 }, {
        default: _withCtx(() => [
          _createElementVNode("video", _hoisted_3, null, 512)
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_van_row, { type: "flex" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.formData.title), 1)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("span", _hoisted_8, _toDisplayString(parseInt(_ctx.formData.visitsCount)?.format2({ simplifyDigits: true })) + "人已看", 1)
            ])
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.formData.siteName) + " / " + _toDisplayString(new Date(_ctx.formData.createTimeStamp)?.format('yyyy-MM-dd HH:mm')), 1),
        _hoisted_10,
        _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.formData.content), 1),
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _hoisted_14,
          _createElementVNode("div", {
            class: "more",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showMore()))
          }, [
            _createTextVNode(" 查看更多 "),
            _createVNode(_component_van_icon, { name: "arrow" })
          ])
        ]),
        _createVNode(_component_van_row, {
          type: "flex ",
          class: "desc",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showCommend()))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_15, [
              _createVNode(_component_van_image, {
                class: "banner-item-img-wrapper item_image",
                width: "100%",
                height: "100%",
                alt: "图片加载中...",
                fit: "cover",
                src: _ctx.formDataRecommend.coverUrl,
                round: "",
                radius: "10"
              }, null, 8, ["src"])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("span", null, _toDisplayString(_ctx.formDataRecommend.title), 1)
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("span", null, _toDisplayString(_ctx.formDataRecommend.content), 1)
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", null, [
                  (_ctx.formDataRecommend.isNew)
                    ? (_openBlock(), _createBlock(_component_van_tag, {
                        key: 0,
                        class: "newTag",
                        plain: "",
                        type: "primary"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("最新")
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_van_tag, {
                    class: "orderTag",
                    plain: "",
                    type: "primary"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.formDataRecommend.siteName), 1)
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("span", _hoisted_20, _toDisplayString(parseInt(_ctx.formDataRecommend.visitsCount)?.format2({ simplifyDigits: true })) + "人已看", 1)
              ])
            ])
          ]),
          _: 1
        })
      ])
    ], 512)
  ], 512)), [
    [_vShow, _ctx.loaded]
  ])
}